module.exports = __webpack_public_path__ + "img/e_3_3_g.4bdc2c00.png";